
import {
    appIconSvg,
    cursorIconSvg,
    fileIconSvg,
    gridIconSvg,
    pieChartIconSvg,
    userIconSvg,
    usersIconSvg,
    zapIconSvg,
} from '@/common/marked/extension-mentions/icon-svgs';

const validDataAttributes = ['segment', 'page', 'feature', 'trackEvent', 'track_event', 'visitor', 'account', 'app', 'productArea'];

export function renderMention (type, id, text, asString = true) {
    const attributes = {
        class: 'mention',
    };

    if (validDataAttributes.includes(type) && id) {
        attributes['data-type'] = type;
        attributes['data-id'] = id;
    }

    // add data-text for potential clickability
    attributes['data-text'] = text;

    const icon = () => {
        switch (type) {
            case 'page':
                return fileIconSvg;
            case 'feature':
                return cursorIconSvg;
            case 'segment':
                return pieChartIconSvg;
            case 'track_event':
            case 'trackEvent':
                return zapIconSvg;
            case 'visitor':
                return userIconSvg;
            case 'account':
                return usersIconSvg;
            case 'app':
                return appIconSvg;
            case 'productArea':
                return gridIconSvg;
        }

        return null;
    };

    const mention = ['span', attributes, icon(), ['span', {}, text]].filter(isDefined);

    return asString ? renderToString(mention) : mention;
}

function renderToString (elementArray) {
    if (!Array.isArray(elementArray)) {
        return String(elementArray);
    }

    const [elementName, attributes, ...children] = elementArray;

    // Build attributes string
    const attrString = Object.entries(attributes || {})
        .map(([key, value]) => `${key}="${value}"`)
        .join(' ');

    // Process children recursively
    const childrenString = children
        .filter(isDefined)
        .map((child) => renderToString(child))
        .join('');

    let tagName = elementName;
    const space = tagName.indexOf(' ');
    if (space > 0) {
        tagName = tagName.slice(space + 1);
    }

    // Return self-closing tag if no children, otherwise full tag with children
    if (children.length === 0) {
        return `<${tagName}${attrString ? ` ${attrString}` : ''}/>`;
    }

    return `<${tagName}${attrString ? ` ${attrString}` : ''}>${childrenString}</${tagName}>`;
}

function isDefined (item) {
    return item !== null && item !== undefined;
}
